<div class="modal-content">

  <div class="modal-header">
    <h5 class="modal-title" id="modal-title-login">{{'Education' | translate}}</h5>
    <button tabindex="10" type="button" class="close" (click)="activeModal.close(false)">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="entity-education">

      <div class="row">

        <div class="col-12 col-sm-6">

          <!-- education level -->
          <div class="form-group">
            <label>{{'Education level' | translate}}</label>
            <select class="form-control" [(ngModel)]="entity.educationLevelId" (change)="setEducationLevelOptions()">
              <option *ngFor="let level of educationLevels" [value]="level.id">
                {{level.name}}
              </option>
            </select>
            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'educationLevelId')">
              <p>{{'Please fill in education level' | translate}}</p>
            </div>
          </div>

          <!-- education profile -->
          <div class="form-group" *ngIf="profileOptions.length > 0">
            <label>{{'Profile' | translate}}</label>
            <select class="form-control" [(ngModel)]="entity.educationProfileId">
              <option *ngFor="let profile of profileOptions" [value]="profile.id">
                {{profile.name | translate}}
              </option>
            </select>
          </div>

          <!-- education program new -->
          <div class="form-group">
            <label>{{'Education name' | translate}}</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <fa-icon [icon]="faGraduationCap"></fa-icon>
                </span>
              </div>
              <span app-typeahead-educationprogram [(ngModel)]="entity.programName" (selectEvent)="handleEducationProgramSelection($event)"></span>
            </div>
            <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'programName')">
              <p>{{'Please fill in education name' | translate}}</p>
            </div>
          </div>

          <!-- phase -->
          <div class="form-group" *ngIf="phaseOptions.length > 0" [ngClass]="{'d-none': entity.graduated}">
            <label>{{'Phase' | translate}}</label>
            <select class="form-control" [(ngModel)]="entity.phase">
              <option *ngFor="let phase of phaseOptions" [value]="phase">
                {{phase | translate}}
              </option>
            </select>
          </div>

          <!-- graduated -->
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input id="graduated" class="custom-control-input" type="checkbox" [(ngModel)]="entity.graduated" />
              <label for="graduated" class="custom-control-label">{{'Graduated' | translate}}</label>
            </div>
          </div>

          <!-- current -->
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input id="isCurrent" class="custom-control-input" type="checkbox" [(ngModel)]="entity.isCurrent" />
              <label for="isCurrent" class="custom-control-label">{{'Current education' | translate}}</label>
            </div>
          </div>

        </div>

        <div class="col-12 col-sm-6">

          <!-- school select mode -->
          <div *ngIf="!useManualSchool">
            <div class="form-group">
              <label>{{'Select a school' | translate}}</label>
              <select class="form-control" [ngModel]="entity.schoolId" (ngModelChange)="onSchoolChange($event)">
                <option [ngValue]="null">{{'Select a school' | translate}}</option>
                <option *ngFor="let school of schools" [ngValue]="school.id">
                  {{school.name}}
                </option>
              </select>
            </div>

            <div class="form-group" *ngIf="schoolClasses.length > 0">
              <label>{{'Select a class' | translate}}</label>
              <select class="form-control" [(ngModel)]="entity.schoolClassId">
                <option [ngValue]="null">{{'Select a class' | translate}}</option>
                <option *ngFor="let cls of schoolClasses" [ngValue]="cls.id">
                  {{cls.name}}
                </option>
              </select>
            </div>

            <div *ngIf="entity.schoolId" class="mb-3">
              <small class="text-muted">
                {{entity.schoolName}} - {{entity.schoolCity}}, {{entity.schoolCountry}}
              </small>
            </div>

            <a class="btn btn-link btn-sm p-0 mb-3" (click)="toggleManualSchool()">
              {{'School not found? Enter manually' | translate}}
            </a>
          </div>

          <!-- manual school mode -->
          <div *ngIf="useManualSchool">
            <a class="btn btn-link btn-sm p-0 mb-3" (click)="toggleManualSchool()">
              {{'Select from list' | translate}}
            </a>

            <div class="form-group">
              <label>{{'Name school' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="entity.schoolName" />
              <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'schoolName')">
                <p>{{'Please fill in school name' | translate}}</p>
              </div>
            </div>

            <div class="form-group">
              <label>{{'City school' | translate}}</label>
              <input type="text" class="form-control" [(ngModel)]="entity.schoolCity" />
              <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'schoolCity')">
                <p>{{'Please fill in school city' | translate}}</p>
              </div>
            </div>

            <div class="form-group">
              <label>{{'Country school' | translate}}</label>
              <select class="form-control" [(ngModel)]="entity.schoolCountry">
                <option *ngFor="let level of locale.availableCountries()" [value]="level.code">
                  {{level.name}}
                </option>
              </select>
              <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'schoolCountry')">
                <p>{{'Please fill in school country' | translate}}</p>
              </div>
            </div>
          </div>

        </div>

      </div>

      <!-- extras -->
      <div class="form-group">
        <label>{{'Courses / minors / electives' | translate}}</label>
        <textarea rows="5" class="form-control" [(ngModel)]="entity.extras"></textarea>
      </div>

      <!-- period -->
      <div class="form-group row">
        <label class="col-12 col-sm-12 col-form-label">{{'Period (from / till)' | translate}}</label>
        <div class="col-12 col-sm-6">
          <input ngbDatepicker [minDate]="longMinDate" class="form-control" [(ngModel)]="entity.startDate" (click)="startdate.toggle()" #startdate="ngbDatepicker" />
          <div class="alert alert-danger validation-error" *ngIf="showValidationError( 'entity', 'startDate')">
            <p>{{'Please fill in start date' | translate}}</p>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <input ngbDatepicker [minDate]="longMinDate" class="form-control" [(ngModel)]="entity.endDate" (click)="enddate.toggle()" #enddate="ngbDatepicker" />
        </div>
      </div>

      <!-- area of interests -->
      <div class="interests">

        <h3>{{'Field of interest' | translate}}</h3>

        <app-selector-areaofinterests [maxAmount]="maxAmount" [(ngModel)]="entity.areaOfInterests"></app-selector-areaofinterests>

      </div>

    </div>

  </div>

  <div class="modal-footer">
    <div class="btn-toolbar flex-grow-1 justify-content-between">
      <button type="button" class="btn btn-outline-secondary" (click)="activeModal.close(false)">{{'Cancel' | translate}}</button>
      <button type="button" class="btn btn-primary" (click)="Save()">{{'Save' | translate}}</button>
    </div>
  </div>
</div>
